import AccessControlModal from './AccessControlModal';

export type { ISubscriptionData } from './AccessControlModal';
export default AccessControlModal;
